<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="prjProductCode"
    >
      <template v-slot:img="{ row }">
        <b-img
          rounded
          alt="Rounded image"
          :src="
            row.productImageUrl
              ? row.productImageUrl
              : '/image/static/img/nopic.jpg'
          "
          style="width: 80px"
        ></b-img>
        <br />
        <span>
          <small>{{ row.productTypeName }}</small>
        </span>
      </template>
      <template v-slot:desc="{ row }">
        <span>{{ row.productNo }}</span>
        <br />
        <span>
          <small>{{ row.productDesc ? row.productDesc : '--' }}</small>
        </span>
        <br />
        <span>
          <small>Size：{{ row.productSpec ? row.productSpec : '--' }}</small>
        </span>
        <br />
        <span>
          <small
            >Weight：{{ row.productWeight ? row.productWeight : '--' }}</small
          >
        </span>
        <br />
        <span>
          <small
            >成本价：{{ row.factoryPrice ? row.factoryPrice : '--' }}</small
          >
          <el-divider direction="vertical"></el-divider>
          <small>报价：{{ row.fobPrice ? row.fobPrice : '--' }}</small>
        </span>
        <!-- <br />
        <span>
          <small
            >Component：{{
              row.productComponentEn ? row.productComponentEn : '--'
            }}</small
          >
        </span> -->
      </template>
      <template v-slot:status="{ row }">
        <div class="d-inline-flex flex-column justify-content-center">
          <b-badge
            class="mb-2"
            :variant="
              row.recommendStatus === 'T'
                ? 'info'
                : row.prjStatus === 'N'
                ? 'secondary'
                : ''
            "
          >
            {{
              row.recommendStatus === 'T'
                ? $l('label_recommend') || '已生成推荐'
                : row.recommendStatus === 'N'
                ? $l('label_recommend_no') || '未推荐'
                : ''
            }}
          </b-badge>
          <b-badge
            class="mb-2"
            :variant="
              row.quotationStatus === 'Q'
                ? 'primary'
                : row.quotationStatus === 'N'
                ? 'secondary'
                : ''
            "
          >
            {{
              row.quotationStatus === 'Q'
                ? $l('label_quoted') || '已生成报价'
                : row.quotationStatus === 'N'
                ? $l('label_quoted_no') || '未报价'
                : ''
            }}
          </b-badge>
          <b-badge
            class="mt-3"
            :variant="
              row.choiceStatus === 'C'
                ? 'success'
                : row.choiceStatus === 'N'
                ? 'secondary'
                : ''
            "
            v-b-tooltip.hover
            :title="row.choiceDesc"
          >
            {{
              row.choiceStatus === 'C'
                ? $l('label_cust_selected') || '客人选中'
                : row.choiceStatus === 'N'
                ? $l('label_cust_selected_no') || '未反馈'
                : ''
            }}
          </b-badge>
        </div>
      </template>
      <template v-slot:user="{ row }">
        <span>{{ row.choiceUserName }}</span>
        <br />
        <span>
          <small>{{ row.choiceTime }}</small>
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('tips_customer_choice') || '反馈选中'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="$emit('openCustChoice', row.prjProductCode)"
              v-if="allow('D')"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="$emit('del', row.prjProductCode)"
              v-if="allow('D')"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tablePage: {
      default: null,
      type: Object
    },
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data() {
    return {
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => {
            this.$emit('submit')
          }
        },
        zoom: true,
        custom: true
      },
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          fixed: 'left',
          align: 'center',
          type: 'seq'
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          type: 'checkbox'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 100,
          slots: {
            default: 'opt'
          }
        },
        {
          field: 'productImageUrl',
          title: this.$l('table_label_image') || '图片',
          width: 110,
          headerAlign: 'center',
          align: 'center',
          slots: { default: 'img' }
        },
        {
          field: 'productDesc',
          minWidth: 250,
          title: this.$l('table_label_product') || '产品',
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'desc' }
        },
        {
          field: 'bizStatus',
          width: 150,
          title: this.$l('table_label_status') || '状态',
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'status' }
        },
        {
          field: 'choiceUserName',
          width: 170,
          title: this.$l('table_label_choise_user') || '选品人',
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'user' }
        }
      ]
    }
  },
  methods: {
    //批量操作的验证操作
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据！',
          type: 'warning'
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.prjProductCode
        })
      }
      return data
    }
  }
}
</script>
